'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true,
});
exports.scale = scale;

var _d3Interop = require('./d3Interop');

function scale(props) {
  var scaleType = props.scale;
  var d3Scale = _d3Interop.d3Scale;
  var func;

  if (scaleType === 'linear') func = d3Scale.scaleLinear();
  else if (scaleType === 'identity') func = d3Scale.scaleIdentity();
  else if (scaleType === 'sqrt') func = d3Scale.scaleSqrt();
  else if (scaleType === 'pow') func = d3Scale.scalePow();
  else if (scaleType === 'log') func = d3Scale.scaleLog();
  else if (scaleType === 'quantize') func = d3Scale.scaleQuantize();
  else if (scaleType === 'quantile') func = d3Scale.scaleQuantile();
  else if (scaleType === 'ordinal') func = d3Scale.scaleOrdinal();
  else if (scaleType === 'band') func = d3Scale.scaleBand();
  else if (scaleType === 'time') func = d3Scale.scaleTime();
  else new Error('Please check your axis scale setting. "' + scaleType + '" scale is invalid. ');

  return _mkScaleSettings(props, func);
}

function _mkScaleSettings(props, func) {
  var range = props.range,
    domain = props.domain,
    scaleType = props.scale,
    bandPaddingInner = props.bandPaddingInner,
    bandPaddingOuter = props.bandPaddingOuter;

  if (range) func.range(range);

  if (domain) func.domain(domain);

  if (scaleType === 'band') {
    func.round(true);

    if (bandPaddingInner) func.paddingInner(bandPaddingInner);
    else func.paddingInner(0.1);

    if (bandPaddingOuter) func.paddingOuter(bandPaddingOuter);
    else func.paddingOuter(0.1);
  }

  return func;
}
